import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function ReturnCarrierServiceIdField(props) {
    return (
        <FormikInput
            name={'additionalData.returnCarrierServiceId'}
            label={'shippingMethods.form.field.additionalData.returnCarrierServiceId.label'}
            placeholder={'shippingMethods.form.field.additionalData.returnCarrierServiceId.placeholder'}
            required={true}
        />
    );
}

export default ReturnCarrierServiceIdField;
